
function networkColor(network) {
    let green = '#158140'
    let orange = '#EE7326'
    let colors = {
        'tecnocasa': green,
        'tecnorete': orange,
        'tec': green,
        'tre': orange,
        'default': green,
    }
    return colors[network] || colors['default'];
      
}


export {
    networkColor,
}